import format from 'date-fns/format';

const oneDay = 1000 * 60 * 60 * 24;
export function getDateFromToday(numDays = 0) {
  const nowTs = Date.now();
  const targetTs = nowTs + oneDay * numDays;
  return format(targetTs, 'YYYY-MM-DD');
}

export function getWeek() {
  return [0, 1, 2, 3, 4, 5, 6, 7].map(getDateFromToday);
}

export function getLanguage() {
  const lang = navigator.language || navigator.browserLanguage;
  return lang.split('-')[0];
}

function deg2rad(deg) {
  return deg * (Math.PI / 180);
}
export function getDistanceInKm(lat1, lon1, lat2, lon2) {
  // console.log(lat1, lon2, lat2, lon2);
  // https://stackoverflow.com/questions/18883601/function-to-calculate-distance-between-two-coordinates-shows-wrong
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1); // deg2rad below
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in km
  return Math.ceil(d / 10) * 10;
}



// WEBPACK FOOTER //
// ./src/utils/helpers.js